/* Copyright (c) 2020-present CloudIO Inc */

import { atom } from '@cloudio-saas/statex';

export const activeTabAtom = atom<number>({
  path: ['console', 'activeTab'],
  defaultValue: 0,
  urlParam: true,
});

export const settingAtom = atom({
  path: ['console', 'setting'],
  defaultValue: false,
});

export const downloadAtom = atom({
  path: ['console', 'download'],
  defaultValue: false,
});

export const debugConsoleSizeAtom = atom({
  path: ['db', 'IoUserSettings', ':userName', 'md', 'debugConsoleSize'],
  defaultValue: 300,
});

export const debugConsoleMinimizedAtom = atom({
  path: ['db', 'IoUserSettings', ':userName', 'md', 'minimizDebugConsole'],
  defaultValue: false,
});

export type DockPosition = 'bottom' | 'right' | 'left';

export const debugConsoleDockPositionAtom = atom<DockPosition>({
  path: ['db', 'IoUserSettings', ':userName', 'md', 'debugConsoleDockPosition'],
  defaultValue: 'bottom',
});

export const statusTextAtom = atom<[string, string, string, string, string]>({
  path: ['console', 'statusText'],
  defaultValue: ['', '', '', '', ''],
});

export interface LogLevels {
  trace: boolean;
  debug: boolean;
  info: boolean;
  warn: boolean;
  error: boolean;
}

export const LogLevelsLabels: Record<keyof LogLevels, string> = {
  trace: 'Trace',
  debug: 'Debug',
  info: 'Info',
  warn: 'Warnings',
  error: 'Errors',
};

export const logLevelsAtom = atom<LogLevels>({
  path: ['db', 'IoUserSettings', ':userName', 'md', 'logLevels'],
  defaultValue: {
    trace: true,
    debug: true,
    info: true,
    warn: true,
    error: true,
  },
});

export const logFilterAtom = atom({
  path: ['db', 'IoUserSettings', ':userName', 'md', 'logFilter'],
  defaultValue: '',
});

export const serverLogFilterAtom = atom({
  path: ['db', 'IoUserSettings', ':userName', 'md', 'serverLogFilter'],
  defaultValue: '',
});
